/**
 * Imports
 */
import navigation from './navigation';
import user from './user';
/**
 * Exports
 */
export default { navigation, user };
